import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/utils';
import { Accordion } from '@/shared-ui/molecules/accordion';
import type { PlpFiltersState } from '../../../hooks/use-plp-filters';
import { FilterGroup } from '../../molecules';

export interface FilterPanelProps {
    filters: Pick<PlpFiltersState, 'groups' | 'isSelected' | 'toggle'>;
    className?: string;
}

export const FilterPanel = ({ filters, className }: FilterPanelProps) => {
    const { t } = useTranslation('plpFilters');

    if (filters.groups.length === 0) {
        return <p className="py-4 text-sm font-light">{t('noFilters')}</p>;
    }

    return (
        <Accordion.Root data-slot="filter-panel" className={cn('flex flex-col', className)}>
            {filters.groups.map((refinement) => (
                <FilterGroup
                    key={refinement.attributeId}
                    refinement={refinement}
                    isSelected={filters.isSelected}
                    onToggle={filters.toggle}
                />
            ))}
        </Accordion.Root>
    );
};
